import React from 'react';

import * as styles from './ProductRatingMaxiSummary.styles';

interface ProductRatingMaxiSummaryProps {
  numberOfReviews: number;
}

export const ProductRatingMaxiSummary = ({ numberOfReviews }: ProductRatingMaxiSummaryProps) => {
  // Grouped the same way ProductRating formats the count beside the title, so
  // the same number does not appear twice on the page in two formats.
  const heading = `${numberOfReviews.toLocaleString('en-GB')} Product review${
    numberOfReviews === 1 ? '' : 's'
  }`;

  return (
    <div css={styles.overallRatingContainer}>
      <h2 css={styles.heading}>{heading}</h2>
    </div>
  );
};
